import httpClient from "@/apis/base/httpclient";

const state = {
    roles:[],
    roleApps:[],
    roleCurrentUser:[],
    roleUserTotalPage:0,
    selected:[]
}
const actions = {
    async getAllRole (context){
        try{
            let res = await RoleAPI.getAllRole();
            context.commit("setAllRole",res.Data)
        }catch(err){
            console.log(err)
        }
    },
    async getAppRole(context, payload){
        try{
            let res = await UserManagerApi.getOneAppRole(payload)
            context.commit("setRoleApp",res)
        }catch(err){
            console.log(err)
        }
    },
    async getUserRole(context, payload){
        try{
            let res = await UserRoleAPI.getUserInRole(payload)
            context.commit("setRoleCurrentUser",res)
        }catch(err){
            console.log(err)
        }
    },
    getSelectedUser(context, payload){
        context.commit("setSelectedUser", payload)
    }
}
const getters = {

}
const mutations = {
    setAllRole(state, data){
        if(data){
            state.roles = data
        }
    },
    setRoleApp(state, data){
        if(data){
            state.roleApps = data
        }
    },
    setRoleCurrentUser(state, data){
        if(data){
            state.roleCurrentUser = data.Data
            state.roleUserTotalPage = data.Total
        }
    },
    setSelectedUser(state, data){
        if(data){
            state.selected = data
        }
    }
}
export default {
    debug: process.env.NODE_ENV !== "production",
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
  };
  